// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"Post-module--cardTitle--3mWkC","author":"Post-module--author--RzIrT","date":"Post-module--date--1N_v5"};